// Spec: docs/plans/frontend-stack.md §3 (skin loader architecture).

import { Suspense, lazy, type ComponentType } from 'react';
import { useSkin } from './lib/hooks/use-skin';

type SkinName = 'modern' | 'legacy';

const SKINS: Record<SkinName, () => Promise<{ default: ComponentType }>> = {
  modern: () => import('./skins/modern'),
  legacy: () => import('./skins/legacy'),
};

function BootSplash() {
  return (
    <div className="grid min-h-dvh place-items-center text-sm text-muted-foreground">
      Loading…
    </div>
  );
}

export function SkinLoader() {
  const skin = useSkin();
  const SkinApp = lazy(SKINS[skin]);
  return (
    <Suspense fallback={<BootSplash />}>
      <SkinApp />
    </Suspense>
  );
}
